import React, { useCallback, useEffect, useRef } from 'react';
import AntLocalization from '../../utils/AntLocalization';

// Splitter doc giua panel trai (UtilsTabs) va panel phai (AntPOSVoucher).
// Drag → thay doi rightWidth. Min/max clamp giu panel trai con khong gian
// hien thi, panel phai du rong cho voucher form.
export default function Splitter(props) {
    const { rightWidth, onChange, min = 400, max = 1100, defaultWidth = 480 } = props;
    const dragging = useRef(false);
    const startX = useRef(0);
    const startWidth = useRef(0);

    const onMouseMove = useCallback(
        (e) => {
            if (!dragging.current) return;
            // Chuot keo SANG TRAI → rightWidth TANG (panel phai rong ra).
            const delta = startX.current - e.clientX;
            const next = Math.max(min, Math.min(max, startWidth.current + delta));
            onChange(next);
        },
        [min, max, onChange]
    );

    const onMouseUp = useCallback(() => {
        if (!dragging.current) return;
        dragging.current = false;
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
    }, []);

    useEffect(() => {
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
        return () => {
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
        };
    }, [onMouseMove, onMouseUp]);

    const onMouseDown = (e) => {
        dragging.current = true;
        startX.current = e.clientX;
        startWidth.current = rightWidth;
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';
        e.preventDefault();
    };

    const onDoubleClick = () => {
        onChange(defaultWidth);
    };

    const title = AntLocalization.translateText({
        vi: 'Kéo để chỉnh kích thước. Nhấp đôi để khôi phục mặc định.',
        en: 'Drag to resize. Double-click to reset to default.',
        fr: 'Glisser pour redimensionner. Double-cliquer pour réinitialiser.',
        es: 'Arrastrar para redimensionar. Doble clic para restablecer.',
        id: 'Seret untuk mengubah ukuran. Klik ganda untuk reset.',
        ja: 'ドラッグでサイズ変更。ダブルクリックでリセット。',
        zh: '拖动调整大小。双击重置默认。',
        ko: '드래그하여 크기 조정. 더블 클릭으로 기본값 재설정.',
        hi: 'आकार बदलने के लिए खींचें। डबल-क्लिक करके रीसेट करें।',
        ar: 'اسحب لتغيير الحجم. انقر نقرًا مزدوجًا لإعادة الضبط.'
    });

    return (
        <div
            className="ant-pos-screen-splitter"
            onMouseDown={onMouseDown}
            onDoubleClick={onDoubleClick}
            title={title}
        >
            <div className="ant-pos-screen-splitter-handle" />
        </div>
    );
}
